// Utilidades del Asistente IA de presupuesto (Capa 3 · ítem 3.5).
// Convierte las partidas que propone GET /budgets/assistant-draft en líneas
// de la rejilla del editor. Sin dependencias del DOM para poder testearlas
// como el resto de utils (jest).

const genId = () =>
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `line-${Date.now()}-${Math.random().toString(36).slice(2)}`;

// Clave estable de una partida propuesta (marca "Añadida" en el panel por
// name+category; las partidas IA ya añadidas al presupuesto llevan source:"ai").
export function assistantLineKey(line) {
  return `${line?.name ?? ""}::${line?.category ?? ""}`;
}

// Convierte una partida del asistente en una línea del presupuesto en edición.
// - Con monthly_amounts (estacionalidad real): pattern "variable", recortada al
//   rango del presupuesto (claves "YYYY-MM": la comparación de texto ordena bien).
//   Si ningún mes cae dentro del rango devuelve null (no se inventa nada).
// - Sin monthly_amounts: recurrente mensual con `amount` (?? para respetar el 0).
// Siempre con source:"ai" (contrato C3: la línea queda auditada como propuesta IA).
export function assistantLineToBudgetLine(line, startMonth, endMonth) {
  const base = {
    id: genId(),
    name: line.name,
    kind: line.kind,
    category: line.category,
    month: null,
    scenario_overrides: null,
    source: "ai",
  };
  const ma = line.monthly_amounts ?? {};
  if (Object.keys(ma).length > 0) {
    const inRange = Object.fromEntries(
      Object.entries(ma).filter(([mo]) => mo >= startMonth && mo <= endMonth)
    );
    if (Object.keys(inRange).length === 0) return null;
    return { ...base, pattern: "variable", amount: null, monthly_amounts: inRange };
  }
  return { ...base, pattern: "recurring", amount: line.amount ?? 0, monthly_amounts: {} };
}
